import Vue from 'vue';

// Import por CAMINHO ESPECÍFICO (não o barrel 'vuetify/lib') para o app
// empacotar SÓ estes componentes + suas dependências — bundle menor,
// importante para dispositivos antigos.
import {
  VCard, VCardTitle, VCardSubtitle, VCardText, VCardActions,
} from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VRadioGroup, VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VIcon } from 'vuetify/lib/components/VIcon';

import Checklist from './Checklist.vue';
import CardText from './components/cards/CardText.vue';
import CardRadio from './components/cards/CardRadio.vue';
import CardCheck from './components/cards/CardCheck.vue';
import CardSelect from './components/cards/CardSelect.vue';
import CardFile from './components/cards/CardFile.vue';

// Cards registrados por nome kebab-case, batendo com `foqtipo` do backend.
// 'card-text' atende também 'card-text-<limite>' (ver utils/tipo-card).
const cards = {
  'card-text': CardText,
  'card-radio': CardRadio,
  'card-check': CardCheck,
  'card-select': CardSelect,
  'card-file': CardFile,
};

// Componentes Vuetify usados pela lib. O app anfitrião pode usar Vuetify
// "a-la-carte" (sem registro global), então a própria lib registra os que precisa.
// Como o Vuetify é externalizado, estes vêm da instância de Vuetify do app.
const vuetifyComponents = {
  VCard, VCardTitle, VCardSubtitle, VCardText, VCardActions, VImg, VBtn, VDialog,
  VSnackbar, VDivider, VTextField, VRadioGroup, VRadio, VCheckbox,
  VSelect, VBottomSheet, VProgressCircular, VIcon,
};

// Registra os cards GLOBALMENTE para que `<component :is="foqtipo">` resolva
// tanto no Checklist quanto nas subquestões dentro de cada card.
// Como 'vue' é externalizado, este Vue é o do app anfitrião.
function registrar(VueCtor) {
  Object.keys(cards).forEach((nome) => {
    if (!VueCtor.options.components[nome]) VueCtor.component(nome, cards[nome]);
  });
  Object.values(vuetifyComponents).forEach((comp) => {
    const nome = comp && comp.options ? comp.options.name : (comp && comp.name);
    if (nome && !VueCtor.options.components[nome]) VueCtor.component(nome, comp);
  });
}

// Efeito ao importar a lib: garante componentes disponíveis mesmo sem Vue.use().
registrar(Vue);

// Plugin: permite `Vue.use(Checklist)` e disponibiliza <checklist> globalmente.
Checklist.install = (VueCtor) => {
  registrar(VueCtor);
  if (!VueCtor.options.components.Checklist) VueCtor.component('Checklist', Checklist);
};

export default Checklist;
export { Checklist };
